import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

export const useShowsCompetitionStrip = () => {
  const { sport } = useSportContext();
  const {
    flags: { useEssenceCompetitionStrip = false },
  } = useFeatureFlags();

  return useEssenceCompetitionStrip && sport === Sport.FOOTBALL;
};
